import Vue from 'vue'
import Vuex from 'vuex'
const ls = require('local-storage')
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    barColor: 'rgba(0, 0, 0, .8), rgba(0, 0, 0, .8)',
    barImage: 'https://demos.creative-tim.com/material-dashboard/assets/img/sidebar-1.jpg',
    classeTur: '',
    navPageToGo: '',
    navPageToBack: '',
    qtd: 0,
    precoTotal: '0,00 kz',
    totalIva: 0,
    isloading: false,
    lancarNotaDe: '',
    idperfilpauta: 0,
    fromMinhaTurmas: false,
    disciplina: '',
    idclasse: 0,
    loggedUser: [],
    instituicaodescricao: ls.get('instituicaodescricao'),
    textMessage: '',
    classMessage: 'msgWorning',
    hasMessage: false,
    objturma: null,
    anoAcademico: 0,
    anoLectivo: 0,
    objcadeira: null,
    bloqueado: [],
    Controlopauta: 0,
    objaluno: null,
    actividades: [],
    produto: null,
    caixaAberta: false,
    itemsFatura: [],
    produtoDetalhe: null,
    popupExtraVisible: false,
    fromStock: false,
    verdialogoemolumento: false,
    tabelaPedidos: [],
    tabelaPedidosSave: [],
    dados: [],
    camposListagemCliente: null,
    camposListagemProduto: null,
    caixaAberto:0,
    plano_obj: null,
    diasRestantes:null,
    loading_pdf: false,
    configuracoes_component: false,
    showDialogGuia: { cartao: false, carta: false, declaracao: false, declaracao_nota: false, ficha: false, guia: false, historico: false, listaestudante: false, estatistica: false, planificacaoEstatistica: false },
    tipoimpressao: null,
    idEmolumento: undefined,
    anoSelected: undefined,
    from:null
  },
  getters: {
    loggedUser (state) {
      return ls.get('token') // axios.js envia para api
    }

  },
  mutations: {

    SET_dialogoemolumento(state, valor) {
      state.verdialogoemolumento = valor;
    },

     SET_popupExtraVisible(state, valor) {
      state.popupExtraVisible = valor;
    },


    lancarNotaDe (state, payload) {
      state.lancarNotaDe = payload[0].param
      state.idperfilpauta = payload[0].idperfilpauta
      // console.log('passsouuuuuuustate: ' + payload)
    },
    textMessage (state, payload) {
      state.textMessage = payload.msg
      state.hasMessage = true
      setTimeout(() => {
        state.hasMessage = false
        state.textMessage = ''
        state.classMessage = 'msgWorning'
      }, payload.timeout)// hide worning and initialize msg  props
    },
    classMessage (state, classMessage) {
      state.classMessage = classMessage
    },
    loggedUser (state, user) {
      
    }
  },
  actions: {

    togglePopupExtraVisible({ commit }, valor) {
      commit('SET_popupExtraVisible', valor);
    },

     toggleNovoEmolumento({ commit }, valor) {
      commit('SET_dialogoemolumento', valor);
    },

    lancarNotaDe (context, payload) {
      context.commit('lancarNotaDe', payload)
      // console.log('passsouuuuu actions: ' + payload[0].param)
    },
    textMessage (context, payload) {
      context.commit('classMessage', payload.classMessage)
      context.commit('textMessage', payload)
    },

    loggedUser (context, user) {
      ls.set('token', user.token) // token enviado axios.js   tudo automatico
      ls.set('role', user.role)
      ls.set('sigla', user.sigla)
      ls.set('i_id', user.instituicao)
      ls.set('nomeUsuario', user.nomeUsuario)
      ls.set('idanolectivo', user.idanolectivo)
      ls.set('idPessoa', user.idPessoa)
      ls.set('anolectivo', user.anolectivo)
      ls.set('instituicaodescricao', user.instituicaodescricao)
      ls.set('uuid', user.uuid)
      ls.set('empresa', user.empresa)
      ls.set('negocio', user.negocio)
      ls.set('email', user.email)
      ls.set('emailEmpresa', user.emailEmpresa)
      ls.set('nif', user.nif)
      ls.set('site', user.site)
      ls.set('provincia', user.provincia)
      ls.set('localidade', user.localidade)
      ls.set('telefone', user.telefone)
      ls.set('integrado', user.integrado)
      ls.set('regime',user.regime),
      ls.set('regime_descricao',user.regime_descricao)
      ls.set('id_negocio',user.id_negocio)
      ls.set('macadress', user.macadress)
      ls.set('diasRestantes',user.diasRestantes)
      ls.set('mudarPassword',user.mudarPassword)
      ls.set('urlPed',user.urlPed)
      ls.set('nivel',user.nivel)
      ls.set('pkUsuario',user.pkUsuario)
      ls.set('descricao_role',user.descricao_role)
      ls.set('tipoMulta', user.tipoMulta)
      ls.set('descricaoAnolectivo',user.descricaoAnolectivo)
      ls.remove('fatal')
      ls.set("nivel_user", user.nivel_user)
      ls.set("dataExpiracao", user.dataExpiracao)
      ls.set("dataActual", user.dataActual)
      ls.set("fkNegocio", user.fkNegocio)
    }
  }
})
